import { Button, HStack, Icon, Kbd, Text } from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";

interface NavSearchProps {
  onClick: () => void;
}

export function NavSearch({ onClick }: NavSearchProps) {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      size="sm"
      borderColor="transparent"
      justifyContent="space-between"
      maxW="150px"
      color="gray.500"
      fontWeight="normal"
      px={2}
    >
      <HStack>
        <Icon as={LuSearch} />
        <Text>Search...</Text>
      </HStack>
      <Kbd>Cmd+K</Kbd>
    </Button>
  );
}
